import React, { useEffect, useContext, useState } from 'react'
import { Link } from 'gatsby'

import SignInUpNav from './components/SignInUpNav'
import ProfileDropdown from './components/ProfileDropdown'
import { Logo } from 'global/layout/header/components/Logo'

import { userContext } from 'global/context/sub-contexts/userContext'

import * as styles from './Header.module.scss'

const Header = () => {
  const user_context = useContext(userContext)
  const { isLoggedIn, getProfile } = useContext(userContext)

  const [points, setPoints] = useState(0)

  useEffect(() => {
    if (isLoggedIn()) {
      setPoints(user_context.points)
    } else {
      setPoints(0)
    }
  }, [user_context.points, isLoggedIn()])
  function formatNumberWithCommas(number) {
    return number.toLocaleString()
  }
  return (
    <header className={styles.root}>
      <div className={styles.headerContainer}>
        <div className={styles.logoContainer}>
          <Logo />
        </div>
        <div className={styles.rightSide}>
          {isLoggedIn() && getProfile().guest === false ? (
            <div className={styles.user}>
              <Link to="/store">
                <span className={styles.userPoints}>
                  {formatNumberWithCommas(points)} points
                </span>
              </Link>
              <ProfileDropdown />
            </div>
          ) : (
            <SignInUpNav />
          )}
        </div>
      </div>
    </header>
  )
}

export default Header
